const dev = false;
const globals = {
    NOMBRE: "IndiaStyle Adrogué",
    WS: "https://amapola.openplus.net.ar/api",
    OPEN: "https://amapola.openplus.net.ar",
    CDN: [],
    enContruccion: false,
    soloCatalogo: false,
    whatsapp: "+5491122608188",
    whatsappLindo: "+54 911 2260-8188",
    anchoCarrito: "75vw",
    INSTAGRAM: "https://www.instagram.com/indiastyle.adrogue",
    FACEBOOK: "https://www.facebook.com/profile.php?id=61574156572953",
    LINKS: [
        { to: "/catalogo/Indumentaria/62", name: "INDUMENTARIA" },
        { to: "/catalogo/Calzado/3", name: "CALZADO" },
        { to: "/catalogo/Bijou/83", name: "BIJOU" },
        { to: "/catalogo/Accesorios/63", name: "ACCESORIOS" }
    ],
    NOIVA: "PAGALO EN 3 CUOTAS SIN INTERES O<br />6 CUOTAS SIN INTERES PARA COMPRAS SUPERIORES A $ 300.000",
    DIRECCION: "Av. Hipólito Yrigoyen 13298, Adrogué, Pcia de Buenos Aires",
    HORARIO: "Domingos a Jueves de 10:00 a 21:00 hs.<br />Viernes y Sábados de 10:00 a 22:00 hs.",
    FILTRO_MARCA: 'india',
    // Si se define el logo aca, no lo trae del sistema
    // LOGO: https://xxxx
    // Para antes de que baje el logo de archivos
    PRELOGO: '/img/logo.png'
};

for(var c = 1; c <= 5; c++) {
    globals.CDN.push("https://cdn" + c + "-amapola.openplus.net.ar");
}

if (dev) {
    globals.WS = "http://localhost:4000/api";
    globals.OPEN = "http://localhost:4000";
}

export default globals;
